module.exports = __webpack_public_path__ + "img/guide_dir_03.eac5b448.png";